import { UpdateEvent } from 'feature/widget/TryOnStore'
import { makeAutoObservable } from 'mobx'

export class WidgetStore {
  user_id: string = ''
  gender: string = ''
  picture: string = ''
  outfits: number = 0
  favorites: number = 0
  last_time: number = 0

  constructor() {
    makeAutoObservable(this)
  }

  update(update: UpdateEvent) {
    this.user_id = update.user_id ?? ''
    this.gender = update.gender ?? ''
    this.picture = update.picture ?? ''
    this.outfits = update.outfits ?? 0
    this.favorites = update.favorites ?? 0
    this.last_time = update.last_time ?? 0
  }

  reset() {
    this.update({})
  }
}
